import Tag from './Tag';

// export types
export type { TagProps } from './Tag';

// export components
export { Tag };
export default Tag;
